'use client';
import { Box, Button, SxProps } from '@mui/material';
import { useState } from 'react';
import Image from 'next/image';

import Optional from '../../Optional';
import { useTranslate } from '@jd/i18n';
import { TBImgType } from '../../../utils/mappers/image';

type Props = {
  beforeImage?: TBImgType;
  afterImage?: TBImgType;
  sx?: SxProps;
  imgStyle?: Record<string, any>;
  buttonSx?: SxProps;
};

const SwitchImage = ({
  beforeImage,
  afterImage,
  sx,
  imgStyle,
  buttonSx,
}: Props) => {
  const t = useTranslate('sections.portfolio');
  const [isAfter, setIsAfter] = useState(true);

  const hasBoth = !!beforeImage?.url && !!afterImage?.url;
  const image = isAfter ? afterImage : beforeImage;

  if (!image) return null;
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        borderRadius: { xs: 0.5, md: 1 },
        bgcolor: 'background.default',
        ...sx,
      }}
    >
      <Optional condition={hasBoth}>
        <Button
          variant="contained"
          sx={{
            border: '1px solid transparent',
            borderColor: 'primary.contrastText',
            position: 'absolute',
            zIndex: 1,
            top: 16,
            left: 16,
            ...buttonSx,
          }}
          onClick={() => {
            setIsAfter((prev) => !prev);
          }}
        >
          {isAfter ? t('after') : t('before')}
        </Button>
      </Optional>
      <Image
        src={image?.url || ''}
        alt={image?.altText || ''}
        fill
        sizes="100vw"
        placeholder={image.blurDataUrl ? 'blur' : 'empty'}
        blurDataURL={image.blurDataUrl}
        style={{
          objectFit: 'cover',
          pointerEvents: 'none',
          filter: isAfter ? undefined : 'grayscale(40%)',
          ...imgStyle,
        }}
      />
    </Box>
  );
};

export default SwitchImage;
